export const CONFIDENCE_LEVEL_START = 10
export const CONFIDENCE_LEVEL_INCREMENT = 20
export const ROUND_PAYMENT = 500
export const ROUND_COST = 10000
export const INDEBTEDNESS_RATE = 0.35
export const INPUT_DEBOUNCE_RATE = 250
